// extracted by mini-css-extract-plugin
export default {"features":"Features_features__mel4E","featureItem":"Features_featureItem__YiQoq"};